import type React from 'react';
import { Table } from '@/components/ui';
import { cn } from '@/lib/utils';
import type { StockLevel } from '@/types/models';
import { Package } from 'lucide-react';

interface StockTableProps {
  items: StockLevel[];
  className?: string;
}

const StockTable: React.FC<StockTableProps> = ({ items, className }) => {
  if (items.length === 0) {
    return (
      <div className={cn('text-center py-12 text-gray-400', className)}>
        <Package className="w-10 h-10 mx-auto mb-2" />
        <p className="text-sm">Нет данных о запасах</p>
      </div>
    );
  }

  return (
    <>
      <div className={cn('md:hidden divide-y divide-gray-100', className)}>
        {items.map((item) => (
          <div key={item.product_id} className="flex items-center gap-3 px-4 py-3">
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-gray-900 truncate">{item.name}</p>
              <p className="text-xs font-mono text-gray-500">{item.sku}</p>
            </div>
            <span
              className={cn(
                'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold shrink-0',
                item.quantity > 0
                  ? 'bg-emerald-100 text-emerald-700'
                  : 'bg-red-100 text-red-700',
              )}
            >
              {item.quantity}
            </span>
          </div>
        ))}
      </div>

      <div className={cn('hidden md:block', className)}>
        <Table>
          <Table.Header>
            <Table.Row>
              <Table.Head>Артикул</Table.Head>
              <Table.Head>Наименование</Table.Head>
              <Table.Head className="text-right">Количество</Table.Head>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {items.map((item) => (
              <Table.Row key={item.product_id}>
                <Table.Cell className="font-mono text-xs text-gray-600">
                  {item.sku}
                </Table.Cell>
                <Table.Cell className="font-medium text-gray-900">
                  {item.name}
                </Table.Cell>
                <Table.Cell className="text-right">
                  <span
                    className={cn(
                      'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold',
                      item.quantity > 0
                        ? 'bg-emerald-100 text-emerald-700'
                        : 'bg-red-100 text-red-700',
                    )}
                  >
                    {item.quantity}
                  </span>
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      </div>
    </>
  );
};

export default StockTable;
